import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteContract($id: ID!) {
        deleteContract(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
